import ReportUtils from '../components/utils';
import { reportDetails as growthReportDetails } from '../components/GrowthReports/reportDetails';
import operationalReportDetails from '../components/OperationalReports/reportDetails';
import tabDetails from '../components/Navigation/tabDetails';
import commonStrings from 'resources/commonStrings';
import reportDetails from '../components/Navigation/reportDetails';
import { format, parseISO } from 'date-fns';

const utils = {
  browserInfo: () => {
    // Pulled from the mighty INTERNET (no original source cited) & modified for our particular needs
    const browser = {};
    const versionInfo = navigator.userAgent.match(/version\/(\d+)/i);

    let mainInfo = navigator.userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    let secondaryInfo = null;

    if (/trident/i.test(mainInfo[1])) {
      secondaryInfo = /\brv[ :]+(\d+)/g.exec(navigator.userAgent) || [];

      browser['name'] = 'IE';
      browser['version'] = secondaryInfo[1] || '';
      browser['osVersion'] =
        navigator.userAgent.indexOf('NT 10.0') > 0 ? '10' : navigator.userAgent.indexOf('NT 6.1') > 0 ? '7' : '';
    }

    if (mainInfo[1] === 'Chrome') {
      secondaryInfo = navigator.userAgent.match(/\b(OPR|Edge)\/(\d+)/);

      if (secondaryInfo != null) {
        browser['name'] = secondaryInfo[1].replace('OPR', 'Opera');
        browser['version'] = secondaryInfo[2];
      }
    }

    mainInfo = mainInfo[2] ? [mainInfo[1], mainInfo[2]] : [navigator.appName, navigator.appVersion, '-?'];

    if (versionInfo) {
      mainInfo.splice(1, 1, versionInfo[1]);
    }

    if (!browser['name']) {
      browser['name'] = mainInfo[0];
      browser['version'] = mainInfo[1];
    }

    return browser;
  },
  getReadableFileSizeString: (fileSizeInBytes) => {
    let i = -1;
    const byteUnits = [' KB', ' MB', ' GB', ' TB', ' PB', ' EB', ' ZB', ' YB'];
    do {
      fileSizeInBytes = fileSizeInBytes / 1024;
      i++;
    } while (fileSizeInBytes >= 1024);

    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
  },
  formatDate: (dateTime) => {
    // may pass undefined during tests
    if (dateTime === undefined) {
      return format(new Date(), 'MM/dd/yy');
    }
    // obj/number
    if (typeof dateTime === 'object' || typeof dateTime === 'number') {
      return format(dateTime, 'MM/dd/yy');
    }
    // string requires parseISO
    return format(parseISO(dateTime), 'MM/dd/yy');
  },
  getUserGrowthReportDetails: (reportsForUser) => {
    return reportsForUser && reportsForUser.mapGrowthReports && reportsForUser.mapGrowthReports.length > 0
      ? ReportUtils.getReportDetails(reportsForUser.mapGrowthReports, growthReportDetails)
      : [];
  },
  getUserOperationalReportDetails: (reportsForUser) => {
    return reportsForUser && reportsForUser.operationalReports && reportsForUser.operationalReports.length > 0
      ? ReportUtils.getReportDetails(reportsForUser.operationalReports, operationalReportDetails)
      : [];
  },
  getAvailableTabs: (reportsForUser) => {
    const availableTabs = [];
    if (reportsForUser && reportsForUser.mapGrowthReports && reportsForUser.mapGrowthReports.length > 0) {
      availableTabs.push(tabDetails.growthReports);
    }
    if (reportsForUser && reportsForUser.operationalReports && reportsForUser.operationalReports.length > 0) {
      availableTabs.push(tabDetails.operationalReports);
    }
    availableTabs.push(tabDetails.reportsQueue);
    return availableTabs;
  },
  getDefaultSelectedTabEndpoint: (availableTabs) => {
    return availableTabs && availableTabs.length > 0 ? availableTabs[0].urlEndPoint : null;
  },
  getTargetEndpoint: (desiredPath, defaultTabEndpoint) => {
    const isDev = commonStrings.developmentEnvironments.includes(process.env.ENV_CHOICE);

    // take dev servers into account
    const devRLP = isDev ? '/reports-landing-page' : '';

    // Generate allowed paths

    const allRoutes = { ...tabDetails, ...reportDetails };
    const allowedPaths = Object.values(allRoutes).reduce((acc, tabDetail) => {
      const endPoint = tabDetail.urlEndPoint;
      // istanbul ignore else
      if (!acc[endPoint]) {
        acc[endPoint] = [];
      }
      acc[endPoint].push(`${devRLP}/${endPoint}`);
      acc[endPoint].push(`${devRLP}/${endPoint}/`);

      if (defaultTabEndpoint === endPoint) {
        acc[endPoint].push(`${devRLP}/`);
        if (isDev) {
          acc[endPoint].push(`${devRLP}`);
          acc[endPoint].push('/');
        }
      }
      return acc;
    }, {});
    // 404 unless the endpoint is valid
    let endpoint = '404';
    // Now find which endpoint the supplied desired path is within
    Object.entries(allowedPaths).some((kvPair) => {
      const key = kvPair[0];
      const value = kvPair[1];
      let isEndpoint = false;
      if (
        value.find((allowedPath) => {
          return allowedPath === desiredPath;
        })
      ) {
        endpoint = key;
        isEndpoint = true;
      }
      // returning true exits some loop
      return isEndpoint;
    });

    return endpoint;
  },
  userHasValidRole: (userRoles) => {
    const validRoles = [
      'ASSESSMENT_COORDINATOR',
      'DATA_ADMINISTRATOR',
      'SCHOOL_ASSESSMENT_COORDINATOR',
      'ADMINISTRATOR',
      'INSTRUCTIONAL_PROVIDER',
    ];
    let isValid = false;
    if (Array.isArray(userRoles)) {
      isValid = userRoles.some((role) => validRoles.includes(role));
    } else if (typeof userRoles === 'string') {
      isValid = validRoles.includes(userRoles);
    }
    return isValid;
  },
  setBrowserInfo: (browserInfo) => {
    const browser = browserInfo.name.toLowerCase();
    const version = 'v' + browserInfo.version;
    const category = browser === 'safari' && browserInfo.version <= 16 ? 'old-browser' : 'modern-browser';
    document.querySelector('html').classList.add(browser, version, category);
  },
};

export default utils;
